import { Widget } from './widget';
import { GridsterItemComponentInterface, GridsterItem } from 'angular-gridster2';
import { WidgetAndConfigId } from '@common/models/widget-and-config-id';


export class DashboardItem implements Widget, WidgetAndConfigId {

  id: number;
  dashboardName: string;
  widgetName: string;
  title?: string;
  rows: number;
  cols: number;
  x: number;
  y: number;
  widgetConfigId?: number;

  compactEnabled?: boolean;
  hasImage?: boolean;               // todo: obsolete?
  dragEnabled?: boolean;
  resizeEnabled?: boolean;
  disabled?: boolean;

  initCallback?: (item: GridsterItem, itemComponent: GridsterItemComponentInterface) => void;

  maxItemRows?: number;
  minItemRows?: number;
  maxItemCols?: number;
  minItemCols?: number;
  minItemArea?: number;
  maxItemArea?: number;
}
